import React, { Component } from 'react';
import PromiseForm from 'shared/components/PromiseForm';
import SpinnerButton from 'shared/components/SpinnerButton';

class SearchReferrals extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { searchTerm: '' };
    this.submitForm = this.submitForm.bind(this);
  }

  submitForm(e) {
    e.preventDefault();
    return this.props.fetch(1, this.state.searchTerm);
  }

  render() {
    const state = this.state;
    const setState = this.setState.bind(this);
    return (
      <div>
        <PromiseForm onSubmit={this.submitForm}>
          {formProps => (
            <form
              className="form-horizontal"
              data-spec-id="search-referrals"
              onSubmit={formProps.onSubmit}
            >
              <div className="control-group">
                <label htmlFor="name" className="control-label">
                  Name
                </label>
                <div className="controls">
                  <input
                    id="name"
                    type="text"
                    value={state.searchTerm}
                    onChange={e => setState({ searchTerm: e.target.value })}
                  />
                  &nbsp;
                  <SpinnerButton className="btn btn-primary" loading={formProps.submitting}>
                    Search
                  </SpinnerButton>
                </div>
              </div>
            </form>
          )}
        </PromiseForm>
        {this.props.referrals &&
          React.createElement(this.props.tableComponent, {
            ...this.props,
            emptyMessage: "I'm sorry, no referrals match your search",
          })}
      </div>
    );
  }
}
export default SearchReferrals;
